// extracted by mini-css-extract-plugin
export default {"docItemContainer":"docItemContainer_c0TR","docItemCol":"docItemCol_z5aJ"};